import React, { useContext } from 'react';
import { useUser } from '../../context/UserContext';

// Import components for different user roles
import IssuerISINs from '../IssuerDetails/IssuerISINs'; // For admin/internal users
import LandingInstruments from '../LandingPages/Instruments'; // For external users

const ConditionalInstrumentsRoute = () => {
  const { userData } = useUser();

  // Check if user is external (only EXTERNAL_USER role)
  const isExternalUser = () => {
    if (!userData || !userData.roles || userData.roles.length === 0) {
      return true; // Default to external if no roles
    }
    
    // Check if user has EXTERNAL_USER role
    return userData.roles.includes('EXTERNAL_USER');
  };

  // Render appropriate component based on user role
  if (isExternalUser()) {
    console.log('Rendering external Instruments component for user:', userData?.username);
    return <LandingInstruments skipLayout={true} />;
  } else {
    console.log('Rendering internal IssuerISINs component for user:', userData?.username);
    return <IssuerISINs />;
  }
};

export default ConditionalInstrumentsRoute;
